module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-fill-913295de.svg";